import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '@/locales/en/translation.json';
import translationENUS from '@/locales/en-US/translation.json';
import translationDA from '@/locales/da/translation.json';
import translationES from '@/locales/es/translation.json';
import translationFR from '@/locales/fr/translation.json';
import translationDE from '@/locales/de/translation.json';

/**
 * i18n configuration
 * Supported languages: English (en), US English (en-US), Danish (da), Spanish (es), French (fr), German (de)
 */

const resources = {
  en: {
    translation: translationEN,
  },
  'en-US': {
    translation: translationENUS,
  },
  da: {
    translation: translationDA,
  },
  es: {
    translation: translationES,
  },
  fr: {
    translation: translationFR,
  },
  de: {
    translation: translationDE,
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
